const actions = {

  INIT_AUTH: async function({getters}, context){
    let auth = await getters['auth']
    this._vm.api.setAuth(auth.token, auth.refresh_token, context)
  },

  LOGIN: async function({commit, dispatch}, opt){
    await commit('SAVE_CONTEXT', opt)
    await commit('SWITCH_CONTEXT', opt.context)
    await dispatch('INIT_AUTH', opt.context)
  },

};

export default actions;